import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section id="home" className="hero-section">
      <div className="hero-background">
        <div className="hero-gradient"></div>
        <div className="hero-pattern"></div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          <div className="hero-badge">
            <span className="badge-icon">🕐</span>
            <span>24/7 Available • Trusted Professional Service</span>
          </div>
          
          <h1 className="hero-title">
            Professional Notary Services for Your 
            <span className="title-highlight"> Peace of Mind</span>
          </h1>
          
          <p className="hero-description">
            Serving clients throughout Ontario with secure, efficient, and reliable notary services. 
            Available 24/7 online or in-person at your convenience.
          </p>
          
          <div className="hero-actions">
            <a href="#contact" className="btn btn-primary btn-lg" aria-label="Book a notary appointment">
              <span>📅</span>
              Book an Appointment
            </a>
            <a href="#services" className="btn btn-outline btn-lg" aria-label="View our notary services">
              <span>📋</span>
              View Services
            </a>
          </div>
          
          <div className="hero-stats">
            <div className="stat">
              <span className="stat-number">500+</span>
              <span className="stat-label">Documents Notarized</span>
            </div>
            <div className="stat">
              <span className="stat-number">Same Day</span>
              <span className="stat-label">Service Available</span>
            </div>
            <div className="stat">
              <span className="stat-number">100%</span>
              <span className="stat-label">Satisfaction Rate</span>
            </div>
          </div>
        </div>
      </div>
      
      <div className="service-highlights">
        <div className="container">
          <div className="highlights-grid">
            <div className="highlight-card">
              <div className="highlight-icon">
                <span>💻</span>
              </div>
              <div className="highlight-content">
                <h3>Online via Meet</h3>
                <p>Convenient remote notarization from anywhere</p>
              </div>
            </div>
            <div className="highlight-card">
              <div className="highlight-icon">
                <span>🏢</span>
              </div>
              <div className="highlight-content">
                <h3>In-Person Visits</h3>
                <p>Traditional notary services at our office</p>
              </div>
            </div>
            <div className="highlight-card">
              <div className="highlight-icon">
                <span>🕐</span>
              </div>
              <div className="highlight-content">
                <h3>Available 24/7</h3>
                <p>Round-the-clock service for urgent needs</p>
              </div>
            </div>
            <div className="highlight-card">
              <div className="highlight-icon">
                <span>🚗</span>
              </div>
              <div className="highlight-content">
                <h3>Mobile Notary</h3>
                <p>We come to your location for added convenience</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;